import HomeContainer from './HomeContainer';

/*
* Home 화면
*/
export default HomeContainer;